import * as React from 'react';
import { RowWithParts } from '../../../types';

interface ContextProps {
	row: RowWithParts;
}

export const RowContext = React.createContext<ContextProps>(null);

const RowContextProvider = RowContext.Provider;
export default RowContextProvider;
